import { capitalizeAssociatedPress } from "../../helpers/string/capitalize";
import { valueToTitle } from "../../helpers";

export const filterSelectItemLabel = (itemLabel: string) =>
  capitalizeAssociatedPress(valueToTitle(itemLabel));
